import urlConfig from '../configs/url-config'
import fetchUtil from '../util/fetchUtil'
import authHeaderUtil from '../util/authHeaderUtil'
import { addToMailingList } from './mailingList'

export default {
  buildBody: async (data) => {
    const method = 'POST'
    const url = `${urlConfig.functionsBaseUrl}/day6Character/build-body`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers, data })
    let buildResponse = {}
    if (response.ok) {
      const { id, buildJobId, buildFileUri } = await response.json()
      buildResponse = {
        dimensionsId: id,
        buildStatusId: buildJobId,
        buildFileUri
      }
    }
    // TODO Handle 503. Pop dialog message that says "wait for previous build"?
    return buildResponse
  },
  getCharacterAssetUri: async (dimensionId) => {
    const method = 'GET'
    const url = `${urlConfig.functionsBaseUrl}/day6Asset/character/${dimensionId}`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers })
    const assetResponse = {}
    if (response.ok) {
      const { assetUri } = await response.json()
      assetResponse.assetUri = assetUri
    }
    return assetResponse
  },
  savePose: async (data) => {
    const method = 'POST'
    const url = `${urlConfig.functionsBaseUrl}/day6PoseAnimation/pose`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers, data })
    let saveResponse = {}
    if (response.ok) {
      const { id, dimensionsId, poseSequenceId, animationGroupId } = await response.json()
      saveResponse = {
        poseId: id,
        dimensionsId,
        poseSequenceId,
        animationGroupId
      }
    } else if (response.status === 304) {
      saveResponse.notModified = true
    }
    return saveResponse
  },

  shareCharacter: async (data) => {
    const method = 'POST'
    const url = `${urlConfig.functionsBaseUrl}/day6DataAccess/share-character`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers, data })
    let shareResponse = {}
    if (response.ok) {
      const { id } = await response.json()
      shareResponse = {
        shareId: id
      }
    }
    return shareResponse
  },

  getSharedCharacter: async (shareId) => {
    const method = 'GET'
    const url = `${urlConfig.functionsBaseUrl}/day6DataAccess/share-character?share-id=${shareId}`
    const response = await fetchUtil.request({ method, url })
    return response.ok ? response.json() : {}
  },

  getShareDimensionsId: async (shareId) => {
    const method = 'GET'
    const url = `${urlConfig.functionsBaseUrl}/day6DataAccess/share-character-dimensions-id?share-id=${shareId}`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers })
    let result = {}
    if (response.ok) {
      const { dimensionsId } = await response.json()
      result = {
        dimensionsId
      }
    }
    return result
  },

  addToMarketingList: async (data) => addToMailingList('day6-marketing', data)
}
